import React, { useEffect, useState } from "react";
import { useLang } from "./i18n";
import {
  ANALYTICS_PREFERENCES_EVENT,
  getAnalyticsConsent,
  loadGoogleAnalytics,
  setAnalyticsConsent,
} from "./analytics";

export default function AnalyticsConsent() {
  const { t } = useLang();
  const [visible, setVisible] = useState(() => getAnalyticsConsent() === null);

  useEffect(() => {
    loadGoogleAnalytics();
    const showPreferences = () => setVisible(true);
    window.addEventListener(ANALYTICS_PREFERENCES_EVENT, showPreferences);
    return () => window.removeEventListener(ANALYTICS_PREFERENCES_EVENT, showPreferences);
  }, []);

  if (!visible) return null;

  const choose = (value) => {
    const wasGranted = getAnalyticsConsent() === "granted";
    setAnalyticsConsent(value);
    setVisible(false);
    // A reload fully removes an already-loaded Google tag after withdrawal.
    if (wasGranted && value === "denied") window.location.reload();
  };

  return (
    <aside
      data-testid="analytics-consent"
      role="dialog"
      aria-label={t.analytics.title}
      className="bb-interactive fixed z-[100] left-4 right-4 bottom-4 mx-auto max-w-[760px] rounded-[18px] border p-5 sm:flex sm:items-center sm:gap-6"
      style={{
        background: "rgba(20, 19, 18, 0.97)",
        borderColor: "rgba(245, 240, 232, 0.18)",
        color: "var(--bb-ink)",
        boxShadow: "0 18px 70px rgba(0,0,0,0.48)",
        backdropFilter: "blur(18px)",
      }}
    >
      <div className="flex-1">
        <p className="ff-mono text-[10px] uppercase tracking-[0.18em]" style={{ color: "var(--bb-red)" }}>
          {t.analytics.title}
        </p>
        <p className="mt-2 ff-sans text-sm leading-6" style={{ color: "var(--bb-ink-muted)" }}>
          {t.analytics.body}
        </p>
      </div>
      <div className="mt-4 flex flex-col gap-2 sm:mt-0 sm:min-w-[170px]">
        <button
          type="button"
          data-testid="analytics-allow"
          onClick={() => choose("granted")}
          className="h-11 rounded-[12px] px-5 ff-sans text-sm font-medium"
          style={{ background: "var(--bb-red)", color: "#0A0A0A" }}
        >
          {t.analytics.allow}
        </button>
        <button
          type="button"
          data-testid="analytics-deny"
          onClick={() => choose("denied")}
          className="h-10 rounded-[12px] px-5 ff-sans text-sm"
          style={{ background: "transparent", color: "var(--bb-ink-muted)" }}
        >
          {t.analytics.deny}
        </button>
      </div>
    </aside>
  );
}
